import type { HttpTransport } from "@common/api/transport";
import type { Product } from "@common/types/Product";

export const createProductsApi = (http: HttpTransport) => ({
  fetchProducts: () => http.get<{ products: Product[] }>("/api/products")
});
